import { useCallback, useState } from 'react'
import { AgoraEngine } from '../rtc/agoraEngine'

export function useLocalTracks(engine: AgoraEngine) {
  const [isAudioMuted, setIsAudioMuted] = useState(false)
  const [isVideoEnabled, setIsVideoEnabled] = useState(true)

  const toggleAudio = useCallback(async () => {
    const enabled = await engine.toggleAudio()
    setIsAudioMuted(!enabled)
    return !enabled
  }, [engine])

  const toggleVideo = useCallback(async () => {
    const enabled = await engine.toggleVideo()
    setIsVideoEnabled(enabled)
    return enabled
  }, [engine])

  return {
    isAudioMuted,
    isVideoEnabled,
    toggleAudio,
    toggleVideo,
  }
}
